import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  show: false,
  header: 'Default Header',
  message: 'Default Message',
  buttons: [
    {
      label: 'Close',
      variant: 'secondary',
      onClickKey: 'close',
    },
  ],
};

const ModalDirtyConfirmationSlice = createSlice({
  name: 'modalDirty',
  initialState,
  reducers: {
    openConfirmation: (state, action) => {
      const { header, message, buttons } = action.payload;
      return {
        ...state,
        show: true,
        header,
        message,
        buttons,
      };
    },
    closeConfirmation: (state) => {
      return {
        ...state,
        show: false,
      };
    },
  },
});

export const { openConfirmation, closeConfirmation } = ModalDirtyConfirmationSlice.actions;
export default ModalDirtyConfirmationSlice.reducer;
